import { ConferenceType, ContactState } from '@wui/im'

import { Guest } from '@/entities/conference-participant'

import { Contact } from '@/shared/types/api'


export interface Room {
  /**
   * @deprecated
   *
   * use {@link Room.pServedUser} instead
   */
  id: string
  pServedUser: string
  name: string
  avatar?: string
  isGroup: boolean
  number: string
  /**
   * @deprecated
   *
   * use {@link Room.contacts} instead
   */
  subscribers: Map<string, Contact>
  /**
   * @deprecated
   *
   * use {@link Room.contacts} instead
   */
  guests?: Map<string, Guest>
  isRecording?: boolean
  contacts?: ContactState[]
  mode?: ConferenceType
  /**
   * Room pin-code
   */
  pin?: string
  /**
   * Room pin-code is enabled
   */
  pinEnabled?: boolean
  isExternal?: boolean
  /**
   * Is an active session exists in room
   */
  isActive?: boolean
  /**
   * Is room added to favorite list
   */
  isPinned?: boolean
  /**
   * strict false if room were deleted
   */
  isEnabled?: boolean
  isAutoRecording?: boolean
  /**
   * Token for guest access to room
   */
  token?: string
}

export interface ReactionPayload {
  eventId: number
  emoji: string
  author: string
  timestamp: number
}

export interface UpdateRoomMemberPayload {
  roomId: string
  number: string
  roomSubscriberGuid: string
}

export type RemoveRoomMember = Omit<UpdateRoomMemberPayload, 'number'>

export interface AddOrRemoveRoomMembers {
  roomId: string;
  members: string[] | undefined;
}

export type AsideNotificationType = 'AddReaction' | 'RemoveReaction' | 'Mention' | 'AddToChat' | 'RemoveFromChat' | 'ChangeRoleToUser' | 'ChangeRoleToModerator'

export type FilterValue = AsideNotificationType | undefined

export interface AsideNotificationItem {
  text: string;
  description: string;
  timestamp: number;
  eventId: number;
  unread: boolean;
  roomId: string;
  pServedUser: string;
  targetEventId: number;
  contact?: Contact;
  type: AsideNotificationType,
  miniature?: string
  from: string
}

export interface AsideNotificationEvent {
  pServedUser?: string,
  eventId: number,
  sender?: string,
  targetEventId?: number,
  message: string,
  timestamp: number,
  miniature?: string
}

export interface ChatMark {
  contactId: string
  eventId: number
}

export interface ChatMarkTimestamp {
  contactId: string
  timestamp: number
}

export interface ReadMarksByMessageEventId {
  [messageEventId: number]: ChatMark[]
}

export interface ReadTimestampByMessageEventId {
  [messageEventId: number]: ChatMarkTimestamp[]
}

export interface ReadMarksByMessageEventIdIndexes {
  [roomId: string]: {
    [contactId: string]: number
  }
}

export type LocalStorageKey = 'microphoneId' | 'webcamId' | 'speakerId' | 'incomingCallSpeakerId' | 'incomingCallSpeakerVolume'

export enum OwnStatus {
  DEFAULT = 0,
  ONLINE = 1,
  ABSENT = 2,
  DO_NOT_DISTURB = 3,
  NEED_APPROVE = 4
}
